// Single source of truth for the "main claim type" taxonomy.
// Keys are stored in MongoDB; labels + descriptions + colors are rendered in the UI.
export const CERTIFICATION_CLAIM_TYPES = [
  {
    value: "strong_sustainability",
    label: "Strong sustainability proof",
    barCls: "bg-leaf",
    borderCls: "border-leaf",
    selectedRingCls: "ring-leaf/60 border-leaf",
    description:
      "These certifications provide some of the strongest evidence that a material or product has a lower environmental impact. They usually verify things like organic fibres, recycled content, responsibly sourced raw materials, biodegradability, compostability, circular design, or broader environmental standards.",
  },
  {
    value: "chemical_safety",
    label: "Chemical safety proof",
    barCls: "bg-amber",
    borderCls: "border-amber",
    selectedRingCls: "ring-amber/60 border-amber",
    description:
      "These certifications show that a textile, material, dye, chemical, or finished product has been tested against restricted or harmful substances. They are important because safer materials are better for people, workers, and the environment.",
  },
  {
    value: "factory_process",
    label: "Factory / process proof",
    barCls: "bg-forest",
    borderCls: "border-forest",
    selectedRingCls: "ring-forest/60 border-forest",
    description:
      "These certifications focus on how and where an item was made. They usually look at factory practices, production systems, worker conditions, environmental management, chemical handling, water use, or supply-chain responsibility.",
  },
  {
    value: "vegan_animal_free",
    label: "Vegan / animal-free proof",
    barCls: "bg-sage",
    borderCls: "border-sage",
    selectedRingCls: "ring-sage/60 border-sage",
    description:
      "These certifications show that a product does not use animal-derived materials such as leather, wool, silk, fur, feathers, down, bone, horn, or other animal-based components.",
  },
  {
    value: "animal_welfare",
    label: "Animal welfare proof",
    barCls: "bg-clay",
    borderCls: "border-clay",
    selectedRingCls: "ring-clay/60 border-clay",
    description:
      "These certifications apply to animal-derived materials such as wool, alpaca, mohair, cashmere, leather, feathers, or down. They aim to verify that animals were treated according to recognised welfare standards and that the material can be traced through the supply chain.",
  },
];

export const CERTIFICATION_CLAIM_TYPE_MAP = Object.fromEntries(
  CERTIFICATION_CLAIM_TYPES.map((c) => [c.value, c])
);

export function claimTypeLabel(value) {
  return CERTIFICATION_CLAIM_TYPE_MAP[value]?.label || null;
}

export function claimTypeDescription(value) {
  return CERTIFICATION_CLAIM_TYPE_MAP[value]?.description || null;
}
